import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import "./ContactForm.css";
import contactImg from "../../assets/ATH LOGOs/logo1.png";
import GSTDetails from "../GSTDetails/GSTDetails";
// import FAQSection from "./FAQSection";
import EventRegistration from "./EventRegistration/EventRegistration";

import FAQ from "./MainFAQSEction/FAQ";


const API_BASE = "https://atlastravelhouse.com";
function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE}/api/contact/`, formData)
      .then(() => {
        setStatus("Query submitted successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(() => setStatus("Something went wrong, please try again."));
  };

  const formVariants = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 20,
        delay: 0.1,
        duration: 2,
      },
    },
  };

  const imageVariants = {
    hidden: { x: 100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 20,
        delay: 0.1,
        duration: 2,
      },
    },
  };

  return (
    <>
    {/* new update */}
    <h1 className="contact-h1">
  Contact Atlas Travel House – Corporate Travel, MICE & Visa Assistance
</h1>

      <div className="contact-form-wrapper">
        <motion.div
          className="form-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={formVariants}
        >
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity(
                  "You can fill your email. Atlas Travel House never spams your email."
                )
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            <input
              type="text"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit">Submit</button>
          </form>
          {status && <p className="status-msg">{status}</p>}
        </motion.div>

        <motion.div
          className="image-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={imageVariants}
        >
          {/* <h2 className="contact-heading">Contact Us</h2> */}
          <img src={contactImg} alt="Contact Illustration" />
        </motion.div>
      </div>

      <div className="gstdetails">
        <GSTDetails />
          <EventRegistration/>

      </div>

        <FAQ/>
    </>
  );
}

export default ContactForm;
